import Id from './Id';
import Name from './Name';
import Created from './Created';
import Updated from './Updated';
import Prefix from './Prefix';
import Currency from './Currency';
import GlaNumber from './GlaNumber';
import Storage from './Storage';
import InvoiceBookTemplate from './InvoiceBookTemplate';
import OwnCompany from './OwnCompany';
import IsProductBillable from './IsProductBillable';
import IsServiceBillable from './IsServiceBillable';
import CashComment from './CashComment';
import TransferComment from './TransferComment';
import Region from './Region';
import IsReal from './IsReal';
import DefaultCopies from './DefaultCopies';

export const labels = {
  Id: 'Azonosító',
  Name: 'Név',
  Prefix: 'Előtag',
  Currency: 'Deviza',
  GlaNumber: 'Főkönyvi szám',
  Storage: 'Raktár',
  InvoiceBookTemplate: 'Sablon',
  OwnCompany: 'Saját cég',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  IsProductBillable: 'Termék számlázandó',
  IsServiceBillable: 'Szolgáltatás számlázandó',
  CashComment: 'Kp. megjegyzés',
  TransferComment: 'Ut. megjegyzés',
  Region: 'Régió',
  IsReal: 'Valódi tömb',
  DefaultCopies: 'Alapértelmezett példányszám',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Prefix'
}, {
  value: 'Currency',
}, {
  value: 'GlaNumber',
}, {
  value: 'Storage',
}, {
  value: 'InvoiceBookTemplate',
}, {
  value: 'OwnCompany',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}, {
  value: 'IsProductBillable',
}, {
  value: 'IsServiceBillable',
}, {
  value: 'CashComment',
}, {
  value: 'TransferComment',
}, {
  value: 'Region',
}, {
  value: 'IsReal',
}, {
  value: 'DefaultCopies',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Prefix'
}, {
  value: 'InvoiceBookTemplate'
}, {
  value: 'Currency',
}, {
  value: 'GlaNumber',
}, {
  value: 'Storage',
}];

export const defaultSort = {
  prop: Name,
  order: 'ascending'
};

export default {
  Id,
  Name,
  Prefix,
  Storage,
  InvoiceBookTemplate,
  Currency,
  GlaNumber,
  OwnCompany,
  Created,
  Updated,
  IsProductBillable,
  IsServiceBillable,
  CashComment,
  TransferComment,
  Region,
  IsReal,
  DefaultCopies,
};
